<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="modal-header">
  <h4 class="modal-title">
    <span>{{ 'MAP_MODAL.MAP_VIEWER' | translate }}</span>
  </h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
  </button>
</div>

<ng-scrollbar class="modal-full ps">
  <google-map #map
    [zoom]="15"
    [options]="mapOptions"
    [center]="mapCenter"
    *ngIf="(hotels?.length > 0 || venues?.length > 0) && mapDataReady"
  >
    <map-marker
      *ngFor="let hotel of hotels; let i = index"
      [position]="{ lat: number(hotel.lat), lng: number(hotel.long) }"
      [icon]="'assets/map_marker2.png'"
      (mapClick)="clickedMarker(hotel, i)"
    >
      <map-info-window>
        <div class="agm-infowindow">
          {{ selectedPlace?.name }}
          <span *ngIf="selectedPlace?.stars">
          ({{ selectedPlace?.stars }}
            <span class="star-ico-wrapper">
          <i class="fas fa-star"></i>
          </span>
          )
        </span>
        </div>
      </map-info-window>
    </map-marker>

    <map-marker
      *ngFor="let venue of venues; let i = index"
      [position]="{ lat: number(venue.lat), lng: number(venue.long) }"
      [icon]="'assets/map_marker.png'"
      (mapClick)="clickedMarker(venue,i)"
    >
      <map-info-window>
        <div class="agm-infowindow">
          {{ selectedPlace.name }}
        </div>
      </map-info-window>
    </map-marker>
  </google-map>
</ng-scrollbar>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-dark btn-xs" (click)="modal.dismiss('Cross click')">
    {{ 'MAP_MODAL.CLOSE' | translate }}
  </button>
</div>
